import React from 'react'
import { Modal, Spinner } from 'react-bootstrap'
import { useForm } from 'react-hook-form';
import { useTranslation } from '../../hooks/useTranslation';

function CompanyVerificationModal({ showModal, isLoading, handleLogin, currentUser, handleClose, checkVerificationCode }) {
    const { t } = useTranslation();

    const {
        register,
        setError,
        handleSubmit,
        formState: { errors },
    } = useForm();

    const useEmail = currentUser.twoFactorUseMail;
    // TODO: remove maskEmail and use currentUser.maskedEmail directly once the API returns it
    const maskEmail = (email) => {
        if (!email) return '';
        const [local, domain] = email.split('@');
        const maskedLocal = local[0] + '***';
        const dotIndex = domain.lastIndexOf('.');
        const maskedDomain = domain[0] + '***' + domain.slice(dotIndex);
        return `${maskedLocal}@${maskedDomain}`;
    }
 
    return (
        <Modal show={showModal} onHide={handleClose} className="login-modal">
            <Modal.Header closeButton >
                <Modal.Title role="heading" aria-label={t("LoginForCompaniesAndOrganizations")}>{t("LoginForCompaniesAndOrganizations")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form onSubmit={handleSubmit((data) => checkVerificationCode(data, setError))} className='m-4'>
                    <div className="mb-3 input-field">
                        <div className='mb-4'>
                            <span>{t('SmsWasSent')} <span className='phonenum'>{useEmail ? maskEmail(currentUser.email) : currentUser.phoneNumber}</span></span>
                        </div>
                        <div>
                            <label htmlFor='code'>{t('VerificationCode')}</label>
                            <input
                                {...register("code", {
                                    required: t("VerificationCode"),
                                })}
                                id="code"
                                type='text'
                            />
                            <span className="text-danger">{errors.code?.message}</span>
                        </div>
                    </div>
                    <div className="mb-3 login-btn input-field">
                        <input
                            type="button"
                            className="link"
                            value={t("SendVerifCodeAgain")}
                            onClick={() => handleLogin()}
                        />
                        <button
                            aria-label={t("LoginActn")}
                            className='comp-modal-login-btn'
                            type='submit'
                            disabled={isLoading}
                        >
                            {isLoading && <Spinner className="spinner" animation="border" />}{t("LoginBtn")}
                        </button>
                    </div>
                </form>
            </Modal.Body>
        </Modal>
    )
}

export default CompanyVerificationModal